import { render, staticRenderFns } from "./EnquiryList.vue?vue&type=template&id=02ec78f8&scoped=true&"
import script from "./EnquiryList.vue?vue&type=script&lang=js&"
export * from "./EnquiryList.vue?vue&type=script&lang=js&"
import style0 from "./EnquiryList.vue?vue&type=style&index=0&id=02ec78f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02ec78f8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
import { VTabsSlider } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCard,VFlex,VSubheader,VTab,VTabItem,VTabs,VTabsItems,VTabsSlider})
